"use client"
import { useEffect, useRef, useState, type ReactNode } from "react"
import "./portal-overlays.css"

export function ConfigSavebar({ children }: { children: ReactNode }) {
  const sentinel = useRef<HTMLDivElement>(null)
  const [stuck, setStuck] = useState(false)
  useEffect(() => {
    const node = sentinel.current
    if (!node) return
    const root = node.closest(".portal-scroll")
    const observer = new IntersectionObserver(([entry]) => {
      setStuck(!entry.isIntersecting && entry.boundingClientRect.top < (entry.rootBounds?.top ?? 0))
    }, { root, threshold: 0 })
    observer.observe(node)
    return () => observer.disconnect()
  }, [])
  return <>
    <div ref={sentinel} className="config-savebar-sentinel" aria-hidden="true" />
    <div className="compact-toolbar config-savebar" data-stuck={stuck}>
      <span className="compact-muted">{stuck ? "配置" : "按需展开，修改后保存"}</span>
      {children}
    </div>
  </>
}
